"use client";

import { type ReactNode, useEffect, useState } from "react";
import { useFiltersNavigationStore } from "@/store/useFiltersNavigationStore";
import { TrendsContentSkeleton } from "@/components/TrendsPageSkeleton";

type FiltersLoadingGateProps = {
  variant: "dashboard" | "map-board";
  showAiOverview?: boolean;
  children: ReactNode;
};

export default function FiltersLoadingGate({
  variant,
  showAiOverview = true,
  children,
}: FiltersLoadingGateProps) {
  const isSyncing = useFiltersNavigationStore((s) => s.isSyncing);
  const [hasHydrated, setHasHydrated] = useState(false);

  useEffect(() => {
    setHasHydrated(true);
  }, []);

  if (isSyncing && hasHydrated) {
    return (
      <TrendsContentSkeleton
        variant={variant}
        showAiOverview={showAiOverview}
      />
    );
  }

  return <>{children}</>;
}
